<template>
  <div>
    <el-form
      :inline="true"
      size="mini"
      :rules="rules"
      ref="form"
      :model="formData"
      label-position="top"
    >
      <el-row>
        <el-form-item
          :label="$l('INDEX.table_label_customer_name') || '客户名称'"
        >
          <el-input
            clearable
            v-model="formData.custName"
            size="mini"
            readonly
            style="width: 250px"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$l('INDEX.table_label_endcustomer_name') || '终端客户名称'"
        >
          <el-input
            clearable
            v-model="formData.endCustName"
            size="mini"
            readonly
            style="width: 200px"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="
            $l('INDEX.order_form_batch_label_shipmentStartDate') ||
              '客户最早交期'
          "
          prop="plannedETD"
        >
          <el-date-picker
            v-model="formData.plannedETD"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
            style="width: 150px"
            disabled
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          :label="
            $l('INDEX.order_form_batch_label_shipmentEndDate') || '客户最晚交期'
          "
        >
          <el-date-picker
            v-model="formData.plannedEndETD"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
            style="width: 150px"
            disabled
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          :label="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
          prop="deliveryDate"
        >
          <el-date-picker
            v-model="formData.deliveryDate"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="
              $l('INDEX.form_label_please_select_cargoReadyDay') ||
                '请选择货好时间'
            "
            disabled
            size="mini"
            style="width: 150px"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          :label="$l('INDEX.order_form_batch_label_dispatchPort') || '发运港口'"
        >
          <dict-select
            filterable
            size="mini"
            v-model="formData.dispatchPort"
            url="/master/port/select"
            :placeholder="
              $l('INDEX.tips_batch_label_dispatchPort') || '请选择发运港口'
            "
            clearable
            :disabled="disabled"
            style="width: 200px"
          >
          </dict-select>
        </el-form-item>
        <el-form-item
          :label="
            $l('INDEX.order_form_batch_label_destinationPort') || '目的港口'
          "
        >
          <dict-select
            filterable
            size="mini"
            v-model="formData.destinationPort"
            url="/master/port/select"
            :placeholder="
              $l('INDEX.tips_batch_label_destinationPort') || '请选择目的港口'
            "
            :selectedLabel.sync="formData.destinationPortName"
            clearable
            :disabled="disabled"
            style="width: 200px"
          >
          </dict-select>
        </el-form-item>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  watch: {},
  mounted() {
    this.getData()
  },
  data() {
    return {
      backDialogVisible: false,
      visible: false,
      formData: { shipmentDate: '', custCode: '' },
      rules: {
        plannedETD: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    getData() {
      if (!this.shipmentCode) return
      this.$api
        .shipmentInfoDetailApi({
          shipmentCode: this.shipmentCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()
      this.$api
        .shipmentInfoSaveByPlanConfirmApi({
          ...this.formData,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.getData()
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
